import React from 'react';

function ApplicationInfo() {
  const date = new Date();
  return (
    <>
      <div className='bg-[#eef0f7] p-4 mt-3 rounded-lg'>
        <h5 className='text-blue-700 font-bold font-sans mb-4'>
          Applicaiton Info
        </h5>

        <span>App Version</span>
        <h6 className='font-bold mb-3'>Version 1.0.0</h6>
        <span>Designed By</span>
        <h6 className='font-bold mb-3'>Static Val</h6>
        <span>Copy Rights</span>
        <h6 className='font-bold mb-3'>
          Copyright {date.getFullYear()}-StaticVal-All rights reserved
        </h6>
      </div>
    </>
  );
}

export default ApplicationInfo;
